<template>
    <section class="content-block partners">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="inner" id="mq">
                       <span v-for="m in media">
                           <a :href="'/media-room/'+m.slug">{{m.title}}</a>
                       </span> |

                    </div>
                    <!-- end inner -->
                </div>
                <!-- end col-12 -->
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </section>

</template>

<script>

    export default {
        props: ['logos'],
        data: function(){
            return {
                media: __media__
            }
        },
        mounted() {

            new Marquee('mq');


        }
    }
</script>

<style scoped lang="scss">

    /* PARTNERS */
    .partners {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: -40px;
        padding: 0;
        position: relative;
        z-index: 2;

        .inner {
            border-radius: 10px;
            width: 100%;
            padding: 10px;
            height: 50px;
            background: #fff;
            box-shadow: 0 0 40px rgba(0, 0, 0, 0.10);
            span {
                margin: 0 10px;
            }
            a {
                color: #020202;
            }



        }
    }

    /* RESPONSIVE MOBILE FIXES */
    @media only screen and (max-width: 767px), only screen and (max-device-width: 767px) {
        .partners {
            padding: 0;
        }
        .partners .inner ul {
            flex-wrap: wrap;
        }
        .partners .inner ul li {
            flex: none;
            width: 33.3333%;
            padding: 15px;
        }
        .partners .inner ul li:last-child {
            display: none;
        }
    }

    @media only screen and (max-width: 991px), only screen and (max-device-width: 991px) {
        .partners .inner ul li:first-child {
            display: none;
        }

    }


</style>


